module.exports = __webpack_public_path__ + "img/homepro2.9cb3830b.png";